
var engravingProductId = 8271788507404;
var rootUrl = (window.Shopify.routes.root + '/').replace('//', '/');
var loading = false;

// uppercase all words delimited by whitespace or specified char
function ucfirstAll(str, delimiter) {
  var char = delimiter && delimiter.length ? delimiter : " "
  if (!str.length || str.indexOf(delimiter) < 0) return str
  let strings = str.split(delimiter)
  let newString = ""
  let i = 0;
  for (let string of strings) {
    if (i > 0) newString += delimiter;
    newString += string.charAt(0).toUpperCase() + string.slice(1)
    i++;
  }

  return newString
}

function updateEngravingProperty(name, value) {
  
  var addToCartForm =
    document.querySelector('form[action="' + rootUrl + 'cart/add"]') ||
    document.querySelector('form[action="/cart/add"]')

  var propertyName = `properties[${name}]`
  var input = addToCartForm.querySelector(`input[name="${propertyName}"]`)

  if (input) {
    // If the hidden input already exists, update its value
    if (!value || !value.length) {
      input.remove()
    } else {
      input.value = value
    }
  } else if (value && value.length) {
    // If the hidden input doesn't exist, create a new one and append it to the form
    var newInput = document.createElement('input')
    newInput.type = 'hidden'
    newInput.name = propertyName
    newInput.value = value
    addToCartForm.appendChild(newInput)
  }
}

function initEngraving() {
  window.mameido = window.mameido || {}
  variant = window.mameido.variant 
  if (!window.mameido.variant) return;
  engravingProduct = window.mameido.engravingProduct
  window.mameido.variant.properties = {}
  window.mameido.engravingProduct.properties = {}
  if (!window.mameido.variant || !window.mameido.variant.id) return

  var submitButton = document.getElementById('engrave_submit')
  var engraveCancel = document.getElementById('engrave_cancel')
  var engravingTextDisplay = document.getElementById('engraving-text-display')

  var engravingResult = document.getElementById('engraving_result')
  var engravingResultText = document.querySelector(
    '#engraving_result #engraving_result_text'
  )
  var engravingResultDelete = document.querySelector(
    '#engraving_result #delete'
  )

  // Apply initial font value
  var initialFont = engravingFonts[engravingFont.value]
  engravingTextDisplay.style.fontFamily = initialFont
  if (engravingResultText) engravingResultText.style.fontFamily = initialFont
  engravingText.value = engravingResultText.textContent
  updateEngravingProperty('_font', engravingFont.value)
  window.mameido.variant.properties['_g_font'] = engravingFont.value
  updateEngravingProperty('text', engravingText.value)
  toggleSubmitButton(engravingText.value)
  // Remove and re-attach handler to prevent duplicates when variant changes
  cartSubmitButton.removeEventListener('click', addEngravingToCart)
  cartSubmitButton.addEventListener('click', addEngravingToCart)

  document.querySelectorAll('.engraving-background').forEach((bg) => {
    bg.style.display = 'none'
  })

  var currentVariantBg = document.querySelector(
    '#eng_bg_wrapper_' + window.mameido.variant.id
  )
  var engravingOptions = document.querySelector('#engraving_options')

  if (currentVariantBg === null) {
    engravingOptions.style.display = 'none'
    updateEngravingProperty('_gr_parent', '')
    updateEngravingProperty('text', '')
    updateEngravingProperty('_font', '')
    window.mameido.variant.properties = {}
    //cartSubmitButton.removeEventListener('click', addEngravingToCart)
    return
  }

  updateEngravingProperty('_gr_parent', window.mameido.variant.id)
  updateEngravingProperty('text', engravingText.value)
  updateEngravingProperty('_font', engravingFont.value)
  window.mameido.variant.properties['_g_text'] = engravingText.value
  window.mameido.variant.properties['_g_font'] = engravingFont.value

  engravingOptions.style.display = 'block'
  currentVariantBg.style.display = 'block'
  toggleSubmitButton()

  // MAMEIDO Gravur: statt des Popups öffnet ein Seitenfenster von rechts (siehe window.mameidoEngravingPanel unten)
  var engravingModal = window.mameidoEngravingPanel

  // MAMEIDO Gravur: Symbol-Auswahl (optional, Theme-Einstellung) und Häkchen
  var engravingEmoji = document.getElementById('engraving-emoji')
  var engravingEmojiDisplay = document.getElementById('engraving-emoji-display')
  var engravingResultEmoji = document.getElementById('engraving_result_emoji')
  var engravingConsent = document.getElementById('engraving-consent')
  if (engravingEmoji) {
    engravingEmoji.addEventListener('change', function () {
      var val = engravingEmoji.value
      // \uFE0E = als Textzeichen darstellen (nicht als farbiges Emoji)
      if (engravingEmojiDisplay) engravingEmojiDisplay.textContent = val ? val + '\uFE0E' : ''
      if (engravingResultEmoji) engravingResultEmoji.textContent = val ? val + '\uFE0E' : ''
      updateEngravingProperty('emoji', val)
    })
  }
  if (engravingConsent) {
    engravingConsent.addEventListener('change', function () {
      toggleSubmitButton(engravingText.value)
    })
  }

  engraveButton.addEventListener('click', function (event) {
    event.preventDefault()
    engravingModal.open()
    engravingText.value = engravingResultText.textContent
  })

  submitButton.addEventListener('click', function (event) {
    event.preventDefault()
    engravingModal.close()
  })

  engravingText.addEventListener('input', function (event) {
    var text = event.target.value
    if (text && text.length) {
      // MAMEIDO Gravur: erlaubt sind alle lateinischen Buchstaben (inkl. Umlaute und Akzente wie é, è, ñ, ç), Ziffern,
      // alle Satz- und Sonderzeichen (z. B. <3 ( ) + & @ # % © ♥ als Tastaturzeichen) und normale Leerzeichen. Nur Emojis
      // (auch eingefügt oder per System-Emoji-Auswahl, samt Variantenselektoren, Hautfarben-Zeichen, Flaggen und
      // unsichtbaren Zeichen) und Schriften, die die Gravurschrift nicht kann (z. B. Kyrillisch, Arabisch), fliegen raus.
      text = text.normalize('NFC')
      text = text.replace(/\p{Extended_Pictographic}\uFE0F/gu, '')
      text = text.replace(/[\p{Emoji_Presentation}\p{Emoji_Modifier}\p{Regional_Indicator}\u{1F000}-\u{1FAFF}\uFE0E\uFE0F\u200B-\u200F\u2028-\u202E\u2060-\u206F\uFEFF]/gu, '')
      text = text.replace(/[^\p{Script=Latin}\p{M}\p{N}\p{P}\p{S}\p{Zs}]/gu, '')
      text = text.replace(/ {2,}/g, ' ').replace(/^ +/, '')
      // Groß-/Kleinschreibung: keine automatische Änderung, der Text bleibt genau so, wie der Kunde ihn getippt hat
      document.querySelector('#charcount #count').textContent = text.length;
      engravingTextDisplay.textContent = text
      console.log("text", text)
      engravingText.value = text
      engravingResult.style.display = 'flex'
      engravingResultText.textContent = text && text.length ? text : ''
      setEngraveState(text)
      //cartSubmitButton.addEventListener('click', addEngravingToCart)
    } else {
      engravingResult.style.display = 'none'
      engravingResultText.textContent = ''
      engravingTextDisplay.textContent = ''
      //cartSubmitButton.removeEventListener('click', addEngravingToCart)
      document.querySelector('#charcount #count').textContent = 0 
    }
    toggleSubmitButton(text)
    updateEngravingProperty('text', text)
  })


  //engravingText.addEventListener('paste', e => {alert('Das Einfügen von Texten ist hier leider nicht möglich'); e.preventDefault()});


  function removeEngraving() {
    engravingTextDisplay.textContent = ''; // Clear the engraving text display
    setEngraveState('');
    if (typeof engravingEmoji !== 'undefined' && engravingEmoji) {
      engravingEmoji.value = '';
      if (engravingEmojiDisplay) engravingEmojiDisplay.textContent = '';
      if (engravingResultEmoji) engravingResultEmoji.textContent = '';
      if (window.mameidoSymbolPicker) window.mameidoSymbolPicker.reset();
      updateEngravingProperty('emoji', '');
    }
    if (typeof engravingConsent !== 'undefined' && engravingConsent) engravingConsent.checked = false;
    engravingText.value = '';
    engravingResultText.textContent = '';
    engravingResult.style.display = 'none';
    updateEngravingProperty('text', ''); // Update the property value to empty
    updateEngravingProperty('_font', '');
    updateEngravingProperty('_gr_parent', '');
    if (window.mameido.variant && window.mameido.variant.properties)
      window.mameido.variant.properties = {};
    toggleSubmitButton();
    //cartSubmitButton.removeEventListener('click', addEngravingToCart);
  
    // If there is an engraving input in the modal, update the engraving text above the button
    var modalEngravingText = document.getElementById('engraving-result-text');
    if (modalEngravingText) {
      modalEngravingText.textContent = '';
    }
  }


  engraveCancel.addEventListener('click', function (event) {
    removeEngraving()
    engravingModal.close()
  })

  engravingResultDelete.addEventListener('click', function (event) {
    removeEngraving()
  })

  engravingFont.addEventListener('change', function (event) {
    var fontStyle = event.target.value
    engravingTextDisplay.style.fontFamily = engravingFonts[fontStyle]
    engravingResultText.style.fontFamily = engravingFonts[fontStyle]
    updateEngravingProperty('_font', fontStyle)
  })
}



function _reverseCartUpdates(updates) {
  var newUpdates = {}
  Object.keys(updates)
    .reverse()
    .forEach((key) => {
      newUpdates[key] = updates[key]
    })
  return newUpdates
}


function collectSelectedGifts(variantId) {
  // Check if there are gift options selected
  var giftOptions = document.querySelectorAll('.gift-option-image')
  var selectedGifts = []
  giftOptions.forEach(function (giftOption) {
    if (giftOption.classList.contains('selected')) {
      var giftProductId = giftOption.getAttribute('data-gift-option-id')
      selectedGifts.push({
        id: giftProductId,
        properties: { _parent: variantId },
      })
    }
  })
  return selectedGifts
}

function addEngravingToCart(event) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  if (loading) {
    return;
  }

  // Loading indicator on add to cart button
  cartSubmitButton.classList.add('btn--loading');

  loading = true;
  
  var variant = window.mameido.variant
  var engravingProduct = window.mameido.engravingProduct;
  var engravingTextValue = engravingText.value;
  var engravingFontValue = engravingFont.value;
  var engravingEmojiEl = document.getElementById('engraving-emoji');
  var engravingEmojiValue = engravingEmojiEl ? engravingEmojiEl.value : '';
  var hasEngravingSet = engravingTextValue && engravingTextValue.length;
  var selectedGifts = collectSelectedGifts(variant.id)
  console.log('selectedGifts 1', selectedGifts)

  // Check if there is an engraving available
  if (hasEngravingSet) {
    // If engraving is available, add the engraving information to the cart item properties
   
    variant.properties = variant.properties || {};
    engravingProduct.properties = engravingProduct.properties || {};

    // Add the engraving information to the cart item properties
    engravingProduct.properties['text'] =
      engravingTextValue && engravingTextValue.length ? engravingTextValue : null;
    engravingProduct.properties['_font'] =
      engravingFontValue && engravingFontValue.length ? engravingFontValue : null;
    // Symbol nur setzen, wenn eines gewählt ist (sonst bleibt die Bestellung wie bisher)
    if (engravingEmojiValue && engravingEmojiValue.length) engravingProduct.properties['emoji'] = engravingEmojiValue;
    else delete engravingProduct.properties['emoji'];
    engravingProduct.properties['_gr_parent'] = variant.id;
    variant.properties['_g_text'] = engravingTextValue && engravingTextValue.length ? engravingTextValue : null;
     variant.properties['_g_font'] = engravingFontValue && engravingFontValue.length ? engravingFontValue : null;
    if (engravingEmojiValue && engravingEmojiValue.length) variant.properties['_g_emoji'] = engravingEmojiValue;
    else delete variant.properties['_g_emoji'];

    var itemsToAddToCart = [variant, ...selectedGifts];
    console.log('selectedGifts', selectedGifts)

     fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: [engravingProduct] }),
      credentials: 'same-origin',
    }).then(function () {
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: itemsToAddToCart }),
        credentials: 'same-origin',
      }).then(function () {
        var cart = new theme.CartDrawer();
        cart.init();
        cart.open();
        cartSubmitButton.classList.remove('btn--loading');
        loading = false;
      });
    });
  } else {

    // If there are selected gift options, add them to the cart
    if (selectedGifts.length) {
      var itemsToAdd = [variant, ...selectedGifts];
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: itemsToAdd }),
        credentials: 'same-origin',
      }).then(function () {
        var cart = new theme.CartDrawer();
        cart.init();
        cart.open();
        cartSubmitButton.classList.remove('btn--loading');
        loading = false;
      });
    } else {
      // If no engraving and no gifts are available, simply add the variant to the cart
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: [window.mameido.variant] }),
        credentials: 'same-origin',
      }).then(function () {
        var cart = new theme.CartDrawer();
        cart.init();
        cart.open();
        cartSubmitButton.classList.remove('btn--loading');
        loading = false;
      });
    }
  }

  return false;
}

function toggleSubmitButton(text) {
  var submitButton = document.getElementById('engrave_submit')
  var engraveCancel = document.getElementById('engrave_cancel')
  var consent = document.getElementById('engraving-consent')
  var consented = !consent || consent.checked

  if (!text || !text.length || !consented) {
    submitButton.disabled = 'disabled'
    submitButton.style.cursor = 'not-allowed'
    engraveCancel.innerText = text && text.length ? 'Zurücksetzen' : 'Abbrechen'
  } else {
    submitButton.disabled = null
    submitButton.style.cursor = null
    engraveCancel.innerText = 'Zurücksetzen'
  }
}

function checkCartConsistency() {
  try {
    fetch(rootUrl + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        var engravings = json.items.filter(
          (currentItem) => currentItem.product_id == engravingProductId
        )
        var updates = {}
        if (!engravings || !engravings.length) return json

        engravings.forEach(function (engraving) {
          var parentId = engraving.properties._gr_parent
          var parentFound = json.items.find(
            (currentItem) => currentItem.id === parentId
          )

          if (
            !parentFound || !parentFound.properties['_g_text'] || parentFound.properties['_g_text'] !== engraving.properties['text'] ||
            (parentFound &&
              Math.abs(
                json.items.indexOf(engraving) - json.items.indexOf(parentFound)
              ) > 1)
          ) {
            var index = json.items.indexOf(engraving) + 1
            updates[engraving.key] = 0
          }
        })

        if (Object.keys(updates).length) {
          if (json.items.length === 1) {
            return fetch(window.Shopify.routes.root + 'cart/clear.js').then(
              (response) => response.json()
            )
          }
          return fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({ updates }),
          }).then((response) => {
            console.log("updates", Object.keys(updates))
            if (Object.keys(updates).length) {
                var cart = new theme.CartDrawer()
                cart.init()
                cart.open()
            }
            return response.json()
          })
        }

        return json
      })
      .catch(function (error) {
        console.error('Error occurred while checking cart consistency:', error);
        throw error;
      });
  } catch (error) {
    console.error('Error occurred while checking cart consistency:', error);
    throw error;
  }
}


function synchronizeCount(event) {
  event.preventDefault()
  event.stopPropagation()
  var key = event.detail[0]
  var qty = event.detail[1]
  var updates = {}
  console.log('[mameido.js] - synchronize cart count')
  return fetch(window.Shopify.routes.root + 'cart.js').then((response) => {
    return response.json().then((cart) => {
      var _cartItems = cart.items

      var changedProduct = _cartItems.find((prod) => prod.key === key)
      var nextItem = _cartItems[_cartItems.indexOf(changedProduct) + 1]

      if (nextItem && nextItem.product_id === engravingProductId) {
        updates[nextItem.key] = qty
        updates = _reverseCartUpdates(updates)
      } else {
        updates[key] = qty
      }

      try {
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ updates }),
        }).then((response) => {
          if (typeof updates[key] == 'undefined') {
            console.log('updates', updates)
            updates = {}
            updates[key] = qty

            return fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              credentials: 'same-origin',
              body: JSON.stringify({ updates }),
            }).then((response) => {
              var cart = new theme.CartDrawer()
              cart.init()
              cart.open()
              return response.json()
            })
          } else {
            var cart = new theme.CartDrawer()
            cart.init()
            cart.open()
            return response.json()
          }
        })
      } catch (e) {
        console.warn(e)
      }
    })
  })
}



function getImageLightness(imageSrc, callback) {
  var img = document.createElement("img");
  img.src = imageSrc;
  img.style.display = "none";
  document.body.appendChild(img);

  var colorSum = 0;

  img.onload = function() {
      // create canvas
      var canvas = document.createElement("canvas");
      canvas.width = this.width;
      canvas.height = this.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(this,0,0);

      var imageData = ctx.getImageData(0,0,canvas.width,canvas.height);
      var data = imageData.data;
      var r,g,b,avg;

      for(var x = 0, len = data.length; x < len; x+=4) {
          r = data[x];
          g = data[x+1];
          b = data[x+2];

          avg = Math.floor((r+g+b)/3);
          colorSum += avg;
      }

      var brightness = Math.floor(colorSum / (this.width*this.height));
      callback(brightness);
  }
}

function setEngravingFontColor() {
  if (!window.mameido.variant || !window.mameido.variant.id) return;
  var image = document.querySelector(
    '#eng_bg_wrapper_' + window.mameido.variant.id +' img'
  )

  if (image) {
    getImageLightness(image.src, function(brightness) {
      var newColor = brightness / 1.41
      var newShadow = newColor - 20
      var display = document.querySelector('#engraving-text-display')
      display.style.backgroundColor = 'rgb(' + newColor + ',' + newColor + ',' + newColor + ')';
      display.style.textShadow = '1px -1px 0px rgba(' + newShadow + ',' + newShadow + ',' + newShadow + ',0.75)';
    })
  }
}

/** ------------------------- MAMEIDO Varianten-Galerie (Ansatz B) ------------------------- **/
/* DOM-Entfernen statt CSS-Verstecken:
   - Nur die Slides der aktiven Variante (+ generische) liegen live in der Flickity.
   - Alle uebrigen Varianten-Slides liegen im Stash (#MameidoSlideStash-<section>),
     ausserhalb der Flickity. Bei variant:change werden die Ziel-Slides aus dem Stash
     in die Flickity gesetzt, die alten zurueck in den Stash, dann Flickity neu gebaut.
   -> Versteckte Bilder existieren nicht als Flickity-Zelle und nicht im Photoswipe-DOM.
   Gescopt auf [data-section-id] -> Quick-Shop-sicher. */

function mameidoBuildSlideshow(section, mainSlider) {
  // Baut die Produkt-Flickity ueber das Theme (childNav-Thumbnail-Sync inklusive) neu auf.
  var thumbSlider = section.querySelector('[data-product-thumbs]') ||
                    section.querySelector('.product__thumbs');
  var thumbScroller = thumbSlider ? thumbSlider.querySelector('.product__thumbs--scroller') : null;

  // initialIndex = erster Slide
  var args = {
    dragThreshold: 25,
    adaptiveHeight: true,
    avoidReflow: true,
    initialIndex: 0,
    childNav: thumbSlider || null,
    childNavScroller: thumbScroller || null,
    childVertical: thumbSlider ? thumbSlider.dataset.position === 'beside' : false,
    pageDots: true,
    wrapAround: true
  };

  // Bevorzugt: ueber theme.Slideshow (bringt Thumbnail-Klick-Sync mit).
  if (window.theme && typeof window.theme.Slideshow === 'function') {
    var slideshow = new window.theme.Slideshow(mainSlider, args);
    mameidoAttachVideoPause(mainSlider);
    mameidoSyncActiveThumb(section, mainSlider);
    mameidoAttachThumbSync(section, mainSlider);
    // Zusaetzlich nach der Event-Loop: theme.Slideshow setzt .is-active teils erst nach
    // dem Init -> wir gleichen als Letzte an, damit kein zweiter Ring stehen bleibt.
    setTimeout(function () { mameidoSyncActiveThumb(section, mainSlider); }, 0);
    return slideshow;
  }
  // Fallback: nacktes Flickity (ohne Theme-Thumbnail-Sync).
  if (typeof Flickity !== 'undefined') {
    var flkty = new Flickity(mainSlider, args);
    mameidoAttachVideoPause(mainSlider);
    mameidoSyncActiveThumb(section, mainSlider);
    mameidoAttachThumbSync(section, mainSlider);
    setTimeout(function () { mameidoSyncActiveThumb(section, mainSlider); }, 0);
    return flkty;
  }
  return null;
}

/* MAMEIDO Thumbnail-Aktiv-Sync (Doppelring-Fix):
   Nach dem Neuaufbau der Galerie (Variantenwechsel) konnte MEHR ALS EIN Thumbnail
   die Klasse .is-active tragen -- z.B. wenn eine Farbe zwei Variantbilder hat, blieb
   die .is-active des zuvor eingesetzten Thumbnails kleben, waehrend theme.Slideshow
   dem ersten Thumbnail erneut .is-active gibt -> zwei Auswahl-Ringe.
   Die \"Wahrheit\" ist Flickitys selectedIndex (genau EIN aktiver Slide). Diese Funktion
   gleicht die Thumbnail-Markierung exakt daran an: genau das Thumbnail mit passendem
   data-index bekommt .is-active, alle anderen verlieren sie.
   Gescopt auf die uebergebene Section -> Quick-Shop-sicher. */
function mameidoSyncActiveThumb(section, mainSlider) {
  if (!section || !mainSlider) return;
  if (typeof Flickity === 'undefined') return;
  var flkty = Flickity.data(mainSlider);
  if (!flkty) return;

  var activeIndex = flkty.selectedIndex;
  if (typeof activeIndex !== 'number') activeIndex = 0;

  // Alle Thumbnail-Links dieser Section durchgehen und .is-active exakt setzen.
  var links = section.querySelectorAll('.product__thumb-item a');
  links.forEach(function (a) {
    var idx = parseInt(a.getAttribute('data-index'), 10);
    var isActive = (idx === activeIndex);
    a.classList.toggle('is-active', isActive);
  });
}

/* Haengt einen einmaligen Flickity-select/change-Listener an, der die Thumbnail-
   Aktiv-Markierung bei JEDEM Slide-Wechsel nachzieht (manuelles Klicken, Wischen,
   Pfeile). Idempotent ueber ein Flag an der Flickity-Instanz. */
function mameidoAttachThumbSync(section, mainSlider) {
  if (typeof Flickity === 'undefined') return;
  var flkty = Flickity.data(mainSlider);
  if (!flkty || typeof flkty.on !== 'function') return;
  if (flkty._mameidoThumbSyncBound) return;
  flkty.on('select', function () {
    mameidoSyncActiveThumb(section, mainSlider);
  });
  flkty.on('change', function () {
    mameidoSyncActiveThumb(section, mainSlider);
  });
  flkty._mameidoThumbSyncBound = true;
}

// Pausiert alle Videos im mainSlider, ausser optional dem aktiven Slide.
function mameidoPauseVideos(mainSlider, exceptSlide) {
  if (!mainSlider) return;
  mainSlider.querySelectorAll('[data-mameido-video] video.mameido-video').forEach(function (vid) {
    var slide = vid.closest('[data-mameido-slide]');
    if (exceptSlide && slide === exceptSlide) return;
    if (!vid.paused) vid.pause();
  });
}

// Haengt einen Flickity-change-Listener an: beim Slide-Wechsel werden Videos
// pausiert, die nicht im neu ausgewaehlten Slide liegen.
function mameidoAttachVideoPause(mainSlider) {
  if (typeof Flickity === 'undefined') return;
  var flkty = Flickity.data(mainSlider);
  if (!flkty || typeof flkty.on !== 'function') return;
  flkty.on('change', function (index) {
    var selected = flkty.selectedElement || null;
    mameidoPauseVideos(mainSlider, selected);
  });
}

function filterMameidoGallery(variantId) {
  if (!variantId) return;
  var sections = document.querySelectorAll('[data-section-id]');

  sections.forEach(function (section) {
    var mainSlider = section.querySelector('.product-slideshow');
    var stash = section.querySelector('.mameido-slide-stash');
    // Keine MAMEIDO-Galerie in dieser Section? -> altes System, nichts tun.
    if (!mainSlider || !stash) return;
    if (!section.querySelector('[data-mameido-slide]') &&
        !stash.querySelector('[data-mameido-slide]')) return;

    var targetId = String(variantId);

    // Liegt bereits die richtige Variante live? (erster nicht-generischer Slide pruefen)
    var liveVariantSlide = mainSlider.querySelector('[data-mameido-slide][data-variant-id]');
    var liveId = liveVariantSlide ? liveVariantSlide.getAttribute('data-variant-id') : null;
    if (liveId === targetId) return; // nichts zu tun

    // 1) Generische Slides merken (bleiben immer), aktive Variantenslides in Stash zurueck.
    var genericSlides = [];
    var oldVariantSlides = [];
    mainSlider.querySelectorAll('[data-mameido-slide]').forEach(function (slide) {
      if (slide.getAttribute('data-generic') === 'true') {
        genericSlides.push(slide);
      } else {
        oldVariantSlides.push(slide);
      }
    });

    // 2) Ziel-Slides aus dem Stash holen.
    var newSlides = stash.querySelectorAll('[data-mameido-slide][data-variant-id="' + targetId + '"]');

    // Vor dem Umbau: laufende Videos im Slider pausieren (kein Hintergrund-Ton).
    mameidoPauseVideos(mainSlider, null);

    // Flickity-Instanz holen & zerstoeren, BEVOR DOM veraendert wird.
    var flkty = (typeof Flickity !== 'undefined') ? Flickity.data(mainSlider) : null;
    if (flkty && typeof flkty.destroy === 'function') flkty.destroy();

    // 3) Alte Variantenslides zurueck in den Stash (versteckt).
    oldVariantSlides.forEach(function (slide) { stash.appendChild(slide); });

    // 4) Neue Variantenslides VOR die generischen Slides in die Flickity setzen.
    var firstGeneric = genericSlides.length ? genericSlides[0] : null;
    if (newSlides.length) {
      newSlides.forEach(function (slide, i) {
        if (i === 0) slide.classList.add('starting-slide');
        slide.classList.remove('secondary-slide');
        if (i > 0) slide.classList.add('secondary-slide');
        if (firstGeneric) {
          mainSlider.insertBefore(slide, firstGeneric);
        } else {
          mainSlider.appendChild(slide);
        }
      });
      // Falls generische vorhanden: deren starting-Markierung entfernen.
      genericSlides.forEach(function (g) { g.classList.remove('starting-slide'); g.classList.add('secondary-slide'); });
    } else {
      // Leerfall: keine variantbilder -> erster generischer wird starting-slide.
      if (firstGeneric) {
        firstGeneric.classList.remove('secondary-slide');
        firstGeneric.classList.add('starting-slide');
      }
    }

    // 5) Thumbnails analog umschalten (separate Funktion haelt es uebersichtlich).
    mameidoSwapThumbs(section, targetId);

    // 6) Flickity neu aufbauen (inkl. Thumbnail-Sync via theme.Slideshow).
    mameidoBuildSlideshow(section, mainSlider);
  });
}

function mameidoSwapThumbs(section, targetId) {
  var scroller = section.querySelector('[data-product-thumbs] .product__thumbs--scroller') ||
                 section.querySelector('.product__thumbs--scroller');
  var thumbStash = section.querySelector('.mameido-thumb-stash');
  if (!scroller || !thumbStash) return;

  // generische Thumbs (bleiben) und alte Varianten-Thumbs (zurueck in Stash) trennen
  var genericThumbs = [];
  var oldThumbs = [];
  scroller.querySelectorAll('[data-mameido-thumb]').forEach(function (t) {
    if (t.getAttribute('data-generic') === 'true') genericThumbs.push(t);
    else oldThumbs.push(t);
  });

  // Ziel-Thumbs aus Stash
  var newThumbs = thumbStash.querySelectorAll('[data-mameido-thumb][data-variant-id="' + targetId + '"]');

  // alte zurueck in Stash
  oldThumbs.forEach(function (t) { thumbStash.appendChild(t); });

  // neue vor die generischen einsetzen
  var firstGenericThumb = genericThumbs.length ? genericThumbs[0] : null;
  newThumbs.forEach(function (t) {
    if (firstGenericThumb) scroller.insertBefore(t, firstGenericThumb);
    else scroller.appendChild(t);
  });

  // data-index aller Live-Thumbs + ihrer <a> neu durchnummerieren (childNav-kritisch)
  var liveThumbs = scroller.querySelectorAll('.product__thumb-item');
  liveThumbs.forEach(function (item, i) {
    item.setAttribute('data-index', i);
    var link = item.querySelector('a[data-product-thumb]');
    if (link) link.setAttribute('data-index', i);
  });
}

function setVariant() {
  document.addEventListener('variant:change', function (event) {
    window.mameido.variant = event.detail.variant;
    console.log('changing variant');
    initEngraving();
    setEngravingFontColor()
    filterMameidoGallery(event.detail.variant.id);
  });
}

function removeAjax(event) {
  if (!event.target.parentNode.classList.contains('cart__remove')) return true;
  event.preventDefault();
  event.stopPropagation();
  var href = event.target.getAttribute('href');
  var query = href.split('?')[1];
  var params = new URLSearchParams(query);
  return theme.cart.changeItem(params.get('id'), params.get('quantity')).then(resp => {
    var cart = new theme.CartDrawer();
    cart.init();
    cart.open();  
  })
}



var cartSubmitButton
var engravingText 
var engravingFont 
var engraveButton 
var originalButtonText

// MAMEIDO Gravur: nur noch eine Schrift (Theme-Einstellung). Die alten Namen bleiben, falls ältere Warenkörbe sie noch tragen.
var engravingFonts = {
  'Signature': 'HathemBosteem',
  'Classic': 'Cormorant',
  'Modern': 'Nunito',
  'DM Serif Display': '"DM Serif Display", serif'
}

function setEngraveState(text) {
  var row = document.querySelector('[data-eng-row]')
  if (!row) return
  var has = !!(text && text.length)
  row.classList.toggle('is-set', has)
  var title = row.querySelector('[data-eng-title]')
  // Text der Zeile kommt aus der Theme-Einstellung (data-eng-title-text); mit Namen steht ein Doppelpunkt dahinter.
  // Ist ein Bild eingestellt (data-eng-image), bleibt es unverändert.
  if (title && !title.hasAttribute('data-eng-image')) {
    var base = title.getAttribute('data-eng-title-text') || 'Gravur'
    title.textContent = has ? base.replace(/:?\s*$/, '') + ':' : base
  }
}

/* MAMEIDO Gravur: Seitenfenster von rechts (Markup in snippets/mameido-engraving.liquid, Hülle aus mameido-info-panels.css) */
window.mameidoEngravingPanel = (function () {
  var panel = null
  var overlay = null
  var lastFocus = null
  var mounted = false
  var root = document.documentElement

  function mount() {
    if (mounted) return
    panel = document.getElementById('eng-panel')
    overlay = document.querySelector('[data-eng-overlay]')
    if (!panel || !overlay) return
    mounted = true
    // direkt unter <body>, damit kein Elternelement das fixed-Layout verschiebt
    document.body.appendChild(overlay)
    document.body.appendChild(panel)
    overlay.addEventListener('click', close)
    var closeBtn = panel.querySelector('[data-eng-close]')
    if (closeBtn) closeBtn.addEventListener('click', close)
    document.addEventListener('keydown', function (event) {
      if (!panel.classList.contains('is-open')) return
      if (event.key === 'Escape') { close(); return }
      if (event.key !== 'Tab') return
      var list = Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea'))
        .filter(function (el) { return el.getClientRects().length > 0 })
      if (!list.length) return
      var first = list[0]
      var last = list[list.length - 1]
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus() }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus() }
    })
  }

  function open() {
    mount()
    if (!mounted) return
    lastFocus = document.activeElement
    overlay.classList.add('is-open')
    panel.classList.add('is-open')
    panel.setAttribute('aria-hidden', 'false')
    root.classList.add('mip-open')
    var body = panel.querySelector('.mip__body')
    if (body) body.scrollTop = 0
    window.setTimeout(function () {
      var field = document.getElementById('engraving-text')
      if (field) field.focus({ preventScroll: true })
    }, 60)
  }

  function close() {
    if (!mounted) return
    overlay.classList.remove('is-open')
    panel.classList.remove('is-open')
    panel.setAttribute('aria-hidden', 'true')
    root.classList.remove('mip-open')
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true })
  }

  return { open: open, close: close, mount: mount }
})()

document.addEventListener('DOMContentLoaded', function () {
  // Initialize cached elements
  // Cached elements
  cartSubmitButton = document.querySelector('button.add-to-cart');
  engravingText = document.getElementById('engraving-text');
  engravingFont = document.getElementById('engraving-font');
  engraveButton = document.querySelector('[data-eng-open]')
  originalButtonText = engraveButton ? engraveButton.textContent : 'G'
  
  setVariant();
  checkCartConsistency();
  document.addEventListener('cart:quantity.cart-cart-drawer', synchronizeCount, true);
  document.addEventListener('cart:quantity.cart-page', synchronizeCount, true);
  document.addEventListener('cart:quantity.cart-header', synchronizeCount, true);
  // Attach the addEngravingToCart function to the cartSubmitButton click event
  if (window.mameidoEngravingPanel) window.mameidoEngravingPanel.mount()
  initEngraving();
  setEngravingFontColor();
  document.addEventListener('click', (event) => removeAjax(event))

  // MAMEIDO: Swatch-Block initialisieren (Sortierung, Sichtbarkeit, Toggle)
  mameidoInitSwatches();

  // MAMEIDO: Swatch-Interaktion (Klick->Variante + Markierung)
  mameidoInitSwatchInteractions();

  // MAMEIDO: Galerie initial filtern (behebt Mismatch beim Laden)
  if (window.mameido && window.mameido.variant && window.mameido.variant.id) {
    filterMameidoGallery(window.mameido.variant.id);
  }

  // MAMEIDO: Video-Pause-Listener an die initial vom Theme gebaute Flickity haengen
  // (falls filterMameidoGallery oben early-returned, weil schon die richtige Variante live ist).
  document.querySelectorAll('[data-section-id]').forEach(function (section) {
    var mainSlider = section.querySelector('.product-slideshow');
    if (mainSlider && mainSlider.querySelector('[data-mameido-video]')) {
      mameidoAttachVideoPause(mainSlider);
    }
  });

  // MAMEIDO: Prioritaets-1-Farbe initial auswaehlen + Slider links starten.
  // Per setTimeout ans Ende der Event-Loop, damit Impulses eigene Initialisierung
  // (setzt die Default-Variante) sicher abgeschlossen ist, bevor wir umschalten.
  setTimeout(mameidoSelectPriorityVariant, 0);

  // MAMEIDO: Verfuegbarkeits-Markierung initial setzen (beide Richtungen).
  // Nach der Prio-Auswahl (die selbst variant:change ausloesen kann); ein zusaetzlicher
  // Aufschub stellt sicher, dass die aktive Swatch markiert ist, bevor wir den Zustand lesen.
  setTimeout(mameidoApplyAvailabilityAll, 0);

  // MAMEIDO: aktuell ausgewaehlte Farb-Kachel horizontal ins Sichtfeld holen.
  // Als Letztes (weiterer setTimeout-Tick), damit sowohl die Prio-Auswahl als auch die
  // Verfuegbarkeits-/Sichtbarkeits-Berechnung abgeschlossen sind und .is-selected steht.
  // Loest den Fall, dass eine per ?variant= angeforderte Farbe (Deeplink) ausserhalb des
  // sichtbaren Slider-Bereichs liegt und der Kunde die Auswahl erst nach Scrollen sieht.
  setTimeout(mameidoScrollSelectedIntoViewAll, 0);
});

/** ------------------------- MAMEIDO Swatch-Block (Phase 5) - Sortierung + Slider/Raster-Toggle ------------------------- **/
/* Liquid liefert ALLE Farben neutral mit data-Attributen. Dieses JS uebernimmt:
   - Sortierung: konfigurierte Swatches (data-swatch-configured="true") nach
     data-swatch-prioritaet (numerisch aufsteigend) VOR die unkonfigurierten.
   - Unkonfigurierte bleiben in DOM-Reihenfolge (= Shopify-Optionsreihenfolge).
   - Darstellung: ALLE Swatches bleiben sichtbar. Standard = horizontaler Slider
     (eine scrollbare Reihe). "Alle anzeigen"-Toggle schaltet auf Raster (umbrechend)
     und zurueck -- rein ueber data-swatch-expanded; es wird NICHTS versteckt.
   Gescopt auf jede <variant-swatches>-Instanz -> Quick-View-sicher. */

function mameidoSortSwatches(grid) {
  // Liefert die Buttons in Zielreihenfolge: konfigurierte (nach prioritaet) zuerst,
  // danach unkonfigurierte in urspruenglicher DOM-Reihenfolge.
  var buttons = Array.prototype.slice.call(grid.querySelectorAll('.mameido-swatch'));

  // Urspruenglichen Index merken, damit unkonfigurierte stabil bleiben.
  buttons.forEach(function (btn, i) { btn._mameidoOrigIndex = i; });

  var configured = buttons.filter(function (b) {
    return b.getAttribute('data-swatch-configured') === 'true';
  });
  var unconfigured = buttons.filter(function (b) {
    return b.getAttribute('data-swatch-configured') !== 'true';
  });

  configured.sort(function (a, b) {
    var pa = parseFloat(a.getAttribute('data-swatch-prioritaet'));
    var pb = parseFloat(b.getAttribute('data-swatch-prioritaet'));
    // Ungueltige/leere Prioritaet ganz nach hinten (innerhalb der konfigurierten).
    if (isNaN(pa)) pa = Infinity;
    if (isNaN(pb)) pb = Infinity;
    if (pa !== pb) return pa - pb;
    // Gleichstand: stabile Reihenfolge ueber Originalindex.
    return a._mameidoOrigIndex - b._mameidoOrigIndex;
  });

  return configured.concat(unconfigured);
}

function mameidoInitSwatchInstance(root) {
  var grid = root.querySelector('[data-swatch-grid]');
  if (!grid) return;

  // Sichtbarkeits-Limit fuer den Slider (Standard 10).
  var limit = parseInt(root.getAttribute('data-visible-limit'), 10);
  if (isNaN(limit) || limit < 1) limit = 10;

  // 1) Sortieren: konfigurierte (nach prioritaet) zuerst, dann unkonfigurierte.
  //    Im DOM neu anordnen (die "Alle anzeigen"-Kachel ist KEINE .mameido-swatch
  //    und wird von mameidoSortSwatches nicht erfasst -> bleibt am Ende stehen).
  var sorted = mameidoSortSwatches(grid);
  var showall = grid.querySelector('[data-swatch-showall]');
  sorted.forEach(function (btn) {
    // Vor die "Alle anzeigen"-Kachel einsortieren, damit diese letztes Element bleibt.
    if (showall) {
      grid.insertBefore(btn, showall);
    } else {
      grid.appendChild(btn);
    }
  });

  // 2) Slider-Sichtbarkeit: nur die ersten <limit> Swatches zeigen, Rest verstecken.
  //    (Im Raster-Modus blendet CSS die versteckten wieder ein.)
  var hiddenCount = 0;
  sorted.forEach(function (btn, i) {
    if (i < limit) {
      btn.classList.remove('mameido-swatch--hidden');
    } else {
      btn.classList.add('mameido-swatch--hidden');
      hiddenCount++;
    }
  });

  // 3) "Alle anzeigen"-Kachel: nur zeigen, wenn es versteckte Farben gibt.
  //    Klick -> aufklappen zum Raster (kein Zurueck; einmal offen bleibt offen).
  if (showall) {
    if (hiddenCount > 0) {
      showall.hidden = false;
      if (!showall._mameidoBound) {
        showall.addEventListener('click', function () {
          // alle Swatches einblenden
          grid.querySelectorAll('.mameido-swatch--hidden').forEach(function (b) {
            b.classList.remove('mameido-swatch--hidden');
          });
          // in den Raster-Modus wechseln (CSS bricht um + blendet die Kachel aus)
          root.setAttribute('data-swatch-expanded', 'true');
          showall.hidden = true;
        });
        showall._mameidoBound = true;
      }
    } else {
      showall.hidden = true;
    }
  }

  // Start im Slider-Modus.
  if (!root.getAttribute('data-swatch-expanded')) {
    root.setAttribute('data-swatch-expanded', 'false');
  }

  // Markiert: fertig initialisiert (CSS-FOUC-Kaschierung reagiert darauf).
  root.setAttribute('data-swatch-ready', 'true');
}

function mameidoInitSwatches() {
  document.querySelectorAll('[data-section-id] variant-swatches.mameido-swatches').forEach(function (root) {
    mameidoInitSwatchInstance(root);
  });
  // Fallback: Instanzen ohne [data-section-id]-Ahn (sollte selten sein).
  document.querySelectorAll('variant-swatches.mameido-swatches').forEach(function (root) {
    if (!root.getAttribute('data-swatch-ready')) mameidoInitSwatchInstance(root);
  });
}

/** ------------------------- MAMEIDO Swatch-Block (Phase 5) - Etappe 2b-Teil-1 ------------------------- **/
/* Interaktion (Picker bleibt sichtbar als Kontrolle):
   - Klick auf Swatch -> passendes natives Farb-Radio im selben [data-section-id]
     finden und .click() ausloesen. Impulse feuert dann 'variant:change' ->
     Preis/Galerie/Groessen-Verfuegbarkeit ziehen automatisch nach.
   - Auf 'variant:change' hoeren -> aktiven Swatch markieren (is-selected/aria-pressed)
     + Label oben ("Farbe — <Wert>") aktualisieren.
   NOCH NICHT: nativen Picker verstecken (kommt in Teil 2). */

// Findet das native Farb-Eingabeelement (radio ODER select-option) zum Farbnamen.
// Sucht zuerst im bevorzugten Container (Section des Swatch-Blocks); findet sich
// dort nichts, wird im GANZEN Dokument gesucht. Grund: nativer Picker und unser
// Swatch-Block liegen in UNTERSCHIEDLICHEN [data-section-id]-Containern (verifiziert).
function mameidoFindColorInputIn(scope, colorName) {
  if (!scope) return null;
  // 1) Radio-Buttons (variant-button.liquid): data-color-name ODER value
  var radios = scope.querySelectorAll('input[data-variant-input][type="radio"]');
  for (var i = 0; i < radios.length; i++) {
    var r = radios[i];
    var byName = r.getAttribute('data-color-name');
    if (byName && byName === colorName) return r;
    if (r.value === colorName) return r;
  }
  // 2) Fallback: <select data-variant-input> (variant-dropdown.liquid)
  var selects = scope.querySelectorAll('select[data-variant-input]');
  for (var s = 0; s < selects.length; s++) {
    var sel = selects[s];
    for (var o = 0; o < sel.options.length; o++) {
      if (sel.options[o].value === colorName) {
        return { _isSelect: true, select: sel, value: colorName };
      }
    }
  }
  return null;
}

function mameidoFindNativeColorInput(preferredScope, colorName) {
  if (!colorName) return null;
  // Bevorzugt im Section-Container des Swatch-Blocks (wichtig bei mehreren Produkten/Seite).
  var hit = preferredScope ? mameidoFindColorInputIn(preferredScope, colorName) : null;
  if (hit) return hit;
  // Fallback: ganzes Dokument (nativer Picker liegt in anderer Section).
  return mameidoFindColorInputIn(document, colorName);
}

// Loest die native Variantenauswahl aus (robust: click + change-Fallback).
function mameidoTriggerNativeColor(target) {
  if (!target) return false;

  if (target._isSelect) {
    // Select: Wert setzen + change feuern.
    target.select.value = target.value;
    target.select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  // Radio: bereits aktiv? dann nichts tun.
  if (target.checked) return true;

  // Primär: nativer Klick (loest Theme-Handler am zuverlaessigsten aus).
  target.click();

  // Fallback: falls click die Auswahl nicht gesetzt hat, manuell + change.
  if (!target.checked) {
    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));
  }
  return true;
}

// Markiert den aktiven Swatch + aktualisiert das Label oben.
function mameidoMarkSelectedSwatch(root, colorName) {
  if (!root) return;
  var grid = root.querySelector('[data-swatch-grid]');
  if (!grid) return;

  grid.querySelectorAll('.mameido-swatch').forEach(function (btn) {
    var isMatch = btn.getAttribute('data-swatch-color') === colorName;
    btn.classList.toggle('is-selected', isMatch);
    btn.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
  });

  var label = root.querySelector('[data-swatch-selected-label]');
  if (label && colorName) label.textContent = colorName;
}

// Liest aus einer Variante den Farbwert (ueber data-color-option-position).
function mameidoColorFromVariant(root, variant) {
  if (!variant) return null;
  var pos = parseInt(root.getAttribute('data-color-option-position'), 10);
  if (isNaN(pos) || pos < 1) pos = 1;
  // Shopify-Variant: option1/option2/option3
  return variant['option' + pos] || null;
}

function mameidoInitSwatchInteraction(root) {
  var sectionEl = root.closest('[data-section-id]') || document;
  var grid = root.querySelector('[data-swatch-grid]');
  if (!grid) return;

  // Klick-Delegation auf dem Grid (funktioniert auch fuer spaeter eingeblendete Swatches).
  if (!grid._mameidoClickBound) {
    grid.addEventListener('click', function (event) {
      var btn = event.target.closest('.mameido-swatch');
      if (!btn || !grid.contains(btn)) return;
      event.preventDefault();

      var colorName = btn.getAttribute('data-swatch-color');
      var target = mameidoFindNativeColorInput(sectionEl, colorName);
      if (target) {
        mameidoTriggerNativeColor(target);
        // Markierung setzen wir optimistisch sofort; variant:change bestaetigt sie ohnehin.
        mameidoMarkSelectedSwatch(root, colorName);
      } else {
        console.warn('[mameido swatch] kein natives Farb-Input fuer:', colorName);
      }
    });
    grid._mameidoClickBound = true;
  }

  // Auf Variantenwechsel hoeren -> Markierung/Label nachziehen (egal wodurch ausgeloest).
  if (!root._mameidoVariantBound) {
    document.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      // Nur reagieren, wenn dieser Block zur selben Section gehoert.
      var evSection = event.target && event.target.closest ? event.target.closest('[data-section-id]') : null;
      // variant:change kommt oft von document; daher Section-Check tolerant halten.
      var colorName = mameidoColorFromVariant(root, variant);
      if (colorName) mameidoMarkSelectedSwatch(root, colorName);
    });
    root._mameidoVariantBound = true;
  }
}

function mameidoInitSwatchInteractions() {
  document.querySelectorAll('variant-swatches.mameido-swatches').forEach(function (root) {
    mameidoInitSwatchInteraction(root);
  });
}


/** ------------------------- MAMEIDO Swatch-Block (Phase 5) - Initiale Prioritaets-Auswahl ------------------------- **/
/* Problem: Beim Aufruf des Listings von aussen (ohne Varianten-Parameter) waehlt
   Shopify seine eigene Default-Variante (= erste Variante in Optionsreihenfolge,
   hier "Blush Kissed"). Unsere data-prioritaet-Sortierung beeinflusst nur die
   ANZEIGE der Swatches, nicht Shopifys initiale Variantenwahl.
   Gewuenscht: die Prioritaet-1-Farbe (erste Kachel im sortierten Grid, hier
   "Pearl Marble") ist beim Laden vorausgewaehlt UND der Slider startet links.

   Loesung: nach den Inits einmalig die erste Swatch-Kachel auswaehlen (ueber die
   erprobte native-Radio-Kopplung) und den Slider auf scrollLeft=0 setzen.
   Schutz: laeuft nur einmal pro Instanz (data-Flag); schaltet nur um, wenn die
   Prioritaets-Farbe nicht ohnehin schon aktiv ist (verhindert Flackern/Schleifen). */

function mameidoSelectPriorityVariantFor(root) {
  if (!root) return;
  // Nur einmal pro Instanz ausfuehren.
  if (root.getAttribute('data-swatch-prio-selected') === 'true') return;

  var grid = root.querySelector('[data-swatch-grid]');
  if (!grid) return;

  // Erste (sichtbare) Swatch-Kachel = Prioritaet-1-Farbe (Grid ist bereits sortiert).
  // Die "Alle anzeigen"-Kachel ist KEINE .mameido-swatch -> wird nicht getroffen.
  var firstSwatch = grid.querySelector('.mameido-swatch');
  if (!firstSwatch) return;

  root.setAttribute('data-swatch-prio-selected', 'true');

  var targetColor = firstSwatch.getAttribute('data-swatch-color');
  if (!targetColor) return;

  // Ist die Prioritaets-Farbe bereits aktiv? Dann nur Slider links sicherstellen.
  var alreadySelected = firstSwatch.classList.contains('is-selected');

  if (!alreadySelected) {
    var sectionEl = root.closest('[data-section-id]') || document;
    var target = mameidoFindNativeColorInput(sectionEl, targetColor);
    if (target) {
      mameidoTriggerNativeColor(target);
      mameidoMarkSelectedSwatch(root, targetColor);
    }
  }

  // Slider nach ganz links setzen, damit die Prioritaets-Kachel sichtbar startet.
  // (Auch wenn die Farbe schon aktiv war, kann der Browser horizontal gescrollt sein.)
  grid.scrollLeft = 0;
}

function mameidoSelectPriorityVariant() {
  // mimeido.comeplink-Schutz: Wenn die URL bereits eine Variante vorgibt
  // (z.B. Klaviyo Back-in-Stock, Google Shopping, Meta Ads: ...?variant=<ID>),
  // darf die Prioritaets-Auswahl NICHT eingreifen -- sonst wird die vom Kunden
  // angeforderte Variante beim Laden mit der Prio-1-Farbe ueberschrieben.
  // Ohne ?variant= bleibt das Verhalten unveraendert (Prio-1 als Standard).
  try {
    if (new URLSearchParams(window.location.search).get('variant')) return;
  } catch (e) { /* URLSearchParams nicht verfuegbar -> Prio-Auswahl wie bisher */ }

  document.querySelectorAll('variant-swatches.mameido-swatches').forEach(function (root) {
    mameidoSelectPriorityVariantFor(root);
  });
}

/** ------------------------- MAMEIDO Swatch: ausgewaehlte Kachel ins Sichtfeld scrollen ------------------------- **/
/* Nach dem Laden die aktuell ausgewaehlte Farb-Kachel (.is-selected) horizontal in den
   sichtbaren Bereich des Sliders holen. Zwei Faelle:
     - OHNE ?variant=: Prio-1-Farbe (Pearl Marble) ist aktiv + steht links -> bleibt links.
     - MIT ?variant= (Deeplink, z.B. Klaviyo/Ads): die angeforderte Farbe kann weiter
       hinten in der Leiste liegen -> wird herangescrollt, damit der Kunde die aktive
       Auswahl sofort sieht.
   Bewusst NUR horizontaler scrollLeft am Grid-Container (NICHT scrollIntoView), damit
   die Seite nicht vertikal springt. Gescopt pro Instanz -> Quick-View-sicher. */
function mameidoScrollSelectedIntoView(root) {
  if (!root) return;
  var grid = root.querySelector('[data-swatch-grid]');
  if (!grid) return;
  // Im aufgeklappten Raster-Modus gibt es kein horizontales Scrollen -> nichts tun.
  if (root.getAttribute('data-swatch-expanded') === 'true') return;

  var selected = grid.querySelector('.mameido-swatch.is-selected');
  if (!selected) return;

  // Aktuelle Positionen relativ zum Viewport; Differenz ergibt die noetige Verschiebung,
  // um die Kachel horizontal im Grid zu zentrieren. offsetLeft ist hier unzuverlaessig
  // (position-Kontexte), daher ueber getBoundingClientRect + vorhandenen scrollLeft.
  var gridRect = grid.getBoundingClientRect();
  var selRect = selected.getBoundingClientRect();
  var offset = (selRect.left - gridRect.left) - (gridRect.width / 2) + (selRect.width / 2);

  // Nur scrollen, wenn ueberhaupt horizontaler Spielraum besteht und ein nennenswerter
  // Versatz vorliegt (vermeidet unnoetiges Ruckeln bei bereits sichtbarer Kachel).
  if (grid.scrollWidth <= grid.clientWidth) return;
  if (Math.abs(offset) < 2) return;

  grid.scrollLeft += offset;
}

function mameidoScrollSelectedIntoViewAll() {
  document.querySelectorAll('variant-swatches.mameido-swatches').forEach(function (root) {
    mameidoScrollSelectedIntoView(root);
  });
}

/** ------------------------- MAMEIDO Verfuegbarkeits-Filterung (Etappe A, Schritt 2) ------------------------- **/
/* Beidseitige Verfuegbarkeits-Markierung. Datengrundlage: der JSON-Block
   <script data-mameido-variant-map> im Swatch-Snippet -- Liste von
   [farb-slug, groesse, available] fuer ALLE existierenden Varianten.

   Dreistufige Logik (aus product.variants ableitbar):
     - existiert + available:true  -> "instock"      (normal, klickbar)
     - existiert + available:false -> "soldout"      (gedimmt + Strich, klickbar)
     - existiert NICHT (keine Variante) -> "nonexistent" (wird spaeter ausgeblendet)

   Beidseitig:
     - Farb-Swatches werden anhand der aktuell gewaehlten GROESSE bewertet.
     - Groessen-Buttons werden anhand der aktuell gewaehlten FARBE bewertet.

   SCHRITT 2 setzt NUR das Attribut data-mameido-avail auf jede Kachel/jeden
   Groessen-Eintrag. NOCH KEINE Optik (kommt in Schritt 3/4 per CSS).

   Gescopt auf [data-section-id] -> Quick-View-sicher. */

// Liest + cached die Variantenmap einer Swatch-Instanz (Quick-View-sicher im Scope).
function mameidoGetVariantMap(root) {
  if (!root) return [];
  if (root._mameidoVariantMap) return root._mameidoVariantMap;
  // Map liegt im selben [data-section-id]-Scope wie der Swatch-Block.
  var scope = root.closest('[data-section-id]') || document;
  var script = scope.querySelector('[data-mameido-variant-map]');
  if (!script) {
    root._mameidoVariantMap = [];
    return root._mameidoVariantMap;
  }
  try {
    root._mameidoVariantMap = JSON.parse(script.textContent) || [];
  } catch (e) {
    console.warn('[mameido avail] Variantenmap nicht parsebar:', e);
    root._mameidoVariantMap = [];
  }
  return root._mameidoVariantMap;
}

// Liest aus einer Variante den GROESSEN-Wert (Spiegel zu mameidoColorFromVariant).
// Farb-Position = data-color-option-position; Groesse = die ANDERE der beiden Optionen.
function mameidoSizeFromVariant(root, variant) {
  if (!variant) return null;
  var pos = parseInt(root.getAttribute('data-color-option-position'), 10);
  if (isNaN(pos) || pos < 1) pos = 1;
  var sizePos = (pos === 1) ? 2 : 1;
  return variant['option' + sizePos] || null;
}

// Ermittelt die aktuell gewaehlte Farbe (Slug) + Groesse aus dem aktiven Zustand.
// Farbe: aus der markierten Swatch-Kachel (data-swatch-slug der .is-selected).
// Groesse: aus dem aktiven Groessen-Radio im Section-Scope.
function mameidoGetCurrentSelection(root) {
  var scope = root.closest('[data-section-id]') || document;

  // Aktive Farbe als Slug (matcht die Map): von der markierten Kachel ablesen.
  var selColor = null;
  var selSwatch = root.querySelector('.mameido-swatch.is-selected');
  if (selSwatch) selColor = selSwatch.getAttribute('data-swatch-slug');

  // Aktive Groesse: aus dem angehakten Groessen-Radio (Fieldset mit data-index="option2"
  // bzw. Legende "Groesse"). Wir lesen den Wert ueber das zugehoerige .variant-input[data-value].
  var selSize = null;
  var sizeFieldset = mameidoFindSizeFieldset(scope, root);
  if (sizeFieldset) {
    var checked = sizeFieldset.querySelector('input[type="radio"]:checked');
    if (checked) selSize = checked.value;
  }

  return { color: selColor, size: selSize };
}

// Findet das Groessen-Fieldset: das variant-input-wrap, dessen Options-Position
// NICHT die Farb-Position ist. Robust ueber data-index="optionN"; Fallback ueber Legende.
// Sucht das Groessen-Fieldset INNERHALB eines konkreten Suchbereichs.
// Primaer ueber data-index="optionN", Fallback ueber Legenden-Text.
function mameidoFindSizeFieldsetIn(searchScope, sizeKey) {
  if (!searchScope) return null;
  var wraps = searchScope.querySelectorAll('.variant-input-wrap');
  for (var i = 0; i < wraps.length; i++) {
    var w = wraps[i];
    // Primaer: data-index am Fieldset (z.B. "option2") ODER an einem inneren .variant-input.
    var idx = w.getAttribute('data-index');
    if (!idx) {
      var inner = w.querySelector('.variant-input[data-index]');
      if (inner) idx = inner.getAttribute('data-index');
    }
    if (idx === sizeKey) return w;
  }
  // Fallback: Legenden-Text "groesse/grösse/size".
  for (var j = 0; j < wraps.length; j++) {
    var legend = wraps[j].querySelector('legend');
    var t = legend ? legend.textContent.toLowerCase() : '';
    if (t.indexOf('gr') === 0 || t.indexOf('size') >= 0 || t.indexOf('grö') >= 0) return wraps[j];
  }
  return null;
}

// Findet das Groessen-Fieldset: das variant-input-wrap, dessen Options-Position
// NICHT die Farb-Position ist. WICHTIG: nativer Picker und Swatch-Block liegen in
// UNTERSCHIEDLICHEN [data-section-id]-Containern (verifiziert) -> erst im bevorzugten
// Scope suchen, dann als Fallback im GANZEN Dokument (analog mameidoFindNativeColorInput).
function mameidoFindSizeFieldset(scope, root) {
  var pos = parseInt(root.getAttribute('data-color-option-position'), 10);
  if (isNaN(pos) || pos < 1) pos = 1;
  var sizePos = (pos === 1) ? 2 : 1;
  var sizeKey = 'option' + sizePos;

  // Bevorzugt im uebergebenen Scope.
  var hit = scope ? mameidoFindSizeFieldsetIn(scope, sizeKey) : null;
  if (hit) return hit;
  // Fallback: ganzes Dokument (Picker liegt in anderer Section).
  return mameidoFindSizeFieldsetIn(document, sizeKey);
}

// Schlaegt in der Map den Zustand fuer eine (farbe, groesse)-Kombi nach.
// Rueckgabe: 'instock' | 'soldout' | 'nonexistent'.
function mameidoLookupState(map, colorSlug, size) {
  for (var i = 0; i < map.length; i++) {
    if (map[i][0] === colorSlug && map[i][1] === size) {
      return map[i][2] ? 'instock' : 'soldout';
    }
  }
  return 'nonexistent';
}

// Kernfunktion: setzt data-mameido-avail auf jede Swatch-Kachel + jeden Groessen-Eintrag.
function mameidoApplyAvailability(root) {
  if (!root) return;
  var map = mameidoGetVariantMap(root);
  if (!map.length) return;

  var sel = mameidoGetCurrentSelection(root);
  var scope = root.closest('[data-section-id]') || document;

  // --- Richtung 1: Farb-Swatches anhand der gewaehlten GROESSE bewerten ---
  // Ist (noch) keine Groesse gewaehlt, bewerten wir die Farbe als verfuegbar,
  // sobald sie in IRGENDEINER Groesse lieferbar ist (kein vorschnelles Ausblenden).
  var grid = root.querySelector('[data-swatch-grid]');
  if (grid) {
    grid.querySelectorAll('.mameido-swatch').forEach(function (btn) {
      var slug = btn.getAttribute('data-swatch-slug');
      var state;
      if (sel.size) {
        state = mameidoLookupState(map, slug, sel.size);
      } else {
        state = mameidoStateAnySize(map, slug);
      }
      btn.setAttribute('data-mameido-avail', state);
    });
  }

  // --- Richtung 2: Groessen-Buttons anhand der gewaehlten FARBE bewerten ---
  var sizeFieldset = mameidoFindSizeFieldset(scope, root);
  if (sizeFieldset) {
    sizeFieldset.querySelectorAll('.variant-input[data-value]').forEach(function (item) {
      var size = item.getAttribute('data-value');
      var state;
      if (sel.color) {
        state = mameidoLookupState(map, sel.color, size);
      } else {
        state = mameidoStateAnyColor(map, size);
      }
      item.setAttribute('data-mameido-avail', state);
    });
  }

  // --- Schritt 5a: Slider-Sichtbarkeit filterbewusst neu berechnen ---
  // Nachdem oben data-mameido-avail auf jede Swatch-Kachel gesetzt wurde, muss das
  // 10er-Limit neu greifen -- aber nur ueber die EXISTIERENDEN Farben (nonexistent
  // zaehlt nicht mit). Liegt in derselben Funktion -> kein zusaetzlicher variant:change.
  mameidoApplyVisibility(root);

  // --- Schritt 5b: Auto-Sprung, falls die aktive Farbe in der neuen Groesse wegfaellt ---
  // Erst NACH dem Setzen der Attribute + Sichtbarkeit pruefen wir, ob die aktuell aktive
  // Farbe in der gewaehlten Groesse "nonexistent" geworden ist. Falls ja: auf die erste
  // verfuegbare Farbe springen (instock bevorzugt, soldout als Fallback).
  mameidoAutoJumpIfNeeded(root);

  // --- Schritt 6: Benachrichtigen-Button (Platzhalter) ein-/ausblenden ---
  // Anhand des Zustands der aktuell gewaehlten Variante (Farbe+Groesse) den nativen
  // Kauf-Button bzw. den Benachrichtigen-Button steuern (rein optisch; Klaviyo folgt
  // in Etappe B). Laeuft als Letztes, damit der Zustand nach einem evtl. Auto-Sprung
  // korrekt gelesen wird.
  mameidoUpdateNotifyButton(root);
}

/* Schritt 6 (Platzhalter): Steuert den Benachrichtigen-Button fuer ausverkaufte Varianten.
   Datengrundlage ist die GEWAEHLTE Variante (Farbe+Groesse) -- nicht einzelne Swatches:
     - aktive Kombi ist "soldout"      -> data-mameido-soldout="true"  am Produkt-Form
       (CSS blendet dann den nativen Kauf-Button aus + den Benachrichtigen-Button ein)
     - aktive Kombi ist instock/nonexistent ODER unvollstaendige Auswahl
       -> data-mameido-soldout="false" (nativer Kauf-Button sichtbar, Notify versteckt)
   Die eigentliche Sichtbarkeit macht CSS deterministisch per Attribut (kein Eingriff in
   das Theme-eigene Button-Handling). Klaviyo-Anbindung folgt in Etappe B.
   Gescopt auf [data-section-id] -> Quick-View-sicher. */
function mameidoUpdateNotifyButton(root) {
  if (!root) return;
  var scope = root.closest('[data-section-id]') || document;

  // Produkt-Form finden (enthaelt Kauf- + Benachrichtigen-Button).
  // WICHTIG: Der Swatch-Block und das Kauf-Form liegen in UNTERSCHIEDLICHEN
  // [data-section-id]-Instanzen (verifiziert -- gleiche ID, aber zwei DOM-Knoten,
  // analog zum nativen Farb-Picker). Daher erst im Scope suchen, dann als Fallback
  // im GANZEN Dokument (wie mameidoFindNativeColorInput / mameidoFindSizeFieldset).
  var form = scope.querySelector('form.product-single__form') ||
             document.querySelector('form.product-single__form');
  if (!form) return;

  // Theme-Editor: Der Block "Benachrichtigen-Zeile" gibt dort eine Markierung aus (siehe snippets/mameido-notify-vars.liquid),
  // dann zeigen wir die Zeile immer, damit man sie einstellen kann. Im Shop gibt es die Markierung nie.
  if (document.querySelector('[data-mameido-notify-preview]')) {
    form.setAttribute('data-mameido-soldout', 'true');
    return;
  }

  var map = mameidoGetVariantMap(root);
  if (!map.length) return;

  var sel = mameidoGetCurrentSelection(root);

  // Nur bei vollstaendiger Auswahl (Farbe UND Groesse) ueberhaupt auf "soldout" gehen.
  var isSoldout = false;
  if (sel.color && sel.size) {
    isSoldout = (mameidoLookupState(map, sel.color, sel.size) === 'soldout');
  }

  form.setAttribute('data-mameido-soldout', isSoldout ? 'true' : 'false');

  // Zusaetzlich das Flag am Container spiegeln (schadet nicht, falls CSS es doch nutzt).
  var blocksList = scope.querySelectorAll('[data-product-blocks]');
  if (!blocksList.length) {
    blocksList = document.querySelectorAll('[data-product-blocks]');
  }
  for (var bi = 0; bi < blocksList.length; bi++) {
    blocksList[bi].setAttribute('data-mameido-soldout', isSoldout ? 'true' : 'false');
  }

  // Gravur- und Geschenk-Snippet bei ausverkaufter Variante ausblenden.
  // Am DOM verifiziert: #engraving_options und .gift_options_wrapper liegen NICHT
  // innerhalb von [data-product-blocks] (in der Desktop-Ansicht rendert das Theme sie
  // an anderer Stelle im Seitenbaum). Ein CSS-Vorfahr-Selektor kann sie daher nicht
  // zuverlaessig treffen -> wir steuern sie positionsunabhaengig per JS.
  //
  // WICHTIG -- ORIGINALE GRAVUR-LOGIK NICHT UEBERSCHREIBEN:
  // Der Original-Code (updateEngraving / Variantenwechsel) steuert #engraving_options
  // ueber el.style.display = 'none' bzw. 'block', abhaengig davon, ob die Variante ein
  // Metafeld-Hintergrundbild (custom.engraving_background) hat. Nicht gravierbare oder
  // bildlose Varianten werden so bewusst versteckt. Wuerden WIR ebenfalls el.style.display
  // anfassen, wuerden wir mit dieser Logik kollidieren (zuletzt: Gravur erschien faelschlich
  // bei einer nicht gravierbaren, ausverkauften Variante).
  //
  // LOESUNG: Wir fassen style.display NICHT an, sondern setzen bei Soldout nur eine
  // KLASSE 'mameido-soldout-hidden'. Eine CSS-Regel macht diese Klasse zu display:none
  // !important -- unabhaengig vom inline display. So bleibt die originale style.display-
  // Logik voll erhalten: bei "verfuegbar + nicht gravierbar" greift weiter das originale
  // display:none, bei "verfuegbar + gravierbar" das originale display:block, und unsere
  // Klasse ueberlagert nur zusaetzlich im Soldout-Fall.
  //
  // withPrevLabel=true: Zusaetzlich das UNMITTELBAR vorausgehende Geschwister-Element
  // mit ausblenden, WENN es ein <label class="variant__label"> ist. Das Geschenk-Snippet
  // rendert die Ueberschrift "GESCHENKOPTIONEN" als eigenes <label> VOR .gift_options_wrapper
  // (nicht darin) -- ohne diesen Zusatz bliebe die Ueberschrift allein stehen. Beim Gravur-
  // Block ist das Label bereits in #engraving_options enthalten -> dort nicht noetig.
  var mameidoToggleSoldoutEls = function(selector, withPrevLabel) {
    var els = document.querySelectorAll(selector);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var targets = [el];
      if (withPrevLabel) {
        var prev = el.previousElementSibling;
        if (prev && prev.classList && prev.classList.contains('variant__label')) {
          targets.push(prev);
        }
      }
      for (var t = 0; t < targets.length; t++) {
        if (isSoldout) {
          targets[t].classList.add('mameido-soldout-hidden');
        } else {
          targets[t].classList.remove('mameido-soldout-hidden');
        }
      }
    }
  };
  mameidoToggleSoldoutEls('#engraving_options', false);
  mameidoToggleSoldoutEls('.gift_options_wrapper', true);
}

/* Schritt 5b: Springt auf die erste verfuegbare Farbe, wenn die aktuell gewaehlte
   Farbe in der gewaehlten Groesse nicht existiert (data-mameido-avail="nonexistent").
   Auswahl-Strategie (in DOM-/Sortier-Reihenfolge):
     1. erste "instock"-Swatch (lieferbar, kaufbar) -- bevorzugt
     2. sonst erste "soldout"-Swatch (existiert, aber ausverkauft) -- Fallback
   Beides ueberspringt "nonexistent" automatisch (die sind via CSS ausgeblendet).

   REKURSIONSSCHUTZ (zentral): Der Sprung loest selbst variant:change aus -> dieser
   ruft erneut mameidoApplyAvailability -> mameidoAutoJumpIfNeeded. Da die neu gewaehlte
   Farbe per Definition NICHT nonexistent ist (wir waehlen gezielt eine existierende),
   terminiert die Logik nach einem Durchlauf. Als zweite Sicherung gegen jeden unerwarteten
   Re-Entry setzen wir waehrend des Sprungs ein Flag am Section-Scope und brechen ab,
   solange es gesetzt ist. */
function mameidoAutoJumpIfNeeded(root) {
  if (!root) return;
  var scope = root.closest('[data-section-id]') || document;

  // Rekursionsschutz: laeuft bereits ein Sprung in dieser Section? -> nichts tun.
  if (scope._mameidoAutoJumping) return;

  var sel = mameidoGetCurrentSelection(root);
  // Ohne gewaehlte Groesse gibt es nichts zu filtern -> kein Sprung.
  if (!sel.size) return;
  // Ohne aktive Farbe (sollte nicht vorkommen) -> nichts zu korrigieren.
  if (!sel.color) return;

  var map = mameidoGetVariantMap(root);
  if (!map.length) return;

  // Existiert die aktuell gewaehlte Farbe in der gewaehlten Groesse? Wenn ja: alles ok.
  var currentState = mameidoLookupState(map, sel.color, sel.size);
  if (currentState !== 'nonexistent') return;

  // Die aktive Farbe gibt es in dieser Groesse nicht -> Zielfarbe suchen.
  var grid = root.querySelector('[data-swatch-grid]');
  if (!grid) return;
  var swatches = Array.prototype.slice.call(grid.querySelectorAll('.mameido-swatch'));

  // 1. Durchlauf: erste instock-Swatch (in DOM-/Sortier-Reihenfolge).
  var target = null;
  for (var i = 0; i < swatches.length; i++) {
    if (swatches[i].getAttribute('data-mameido-avail') === 'instock') {
      target = swatches[i];
      break;
    }
  }
  // 2. Durchlauf (Fallback): erste soldout-Swatch, falls keine lieferbar ist.
  if (!target) {
    for (var j = 0; j < swatches.length; j++) {
      if (swatches[j].getAttribute('data-mameido-avail') === 'soldout') {
        target = swatches[j];
        break;
      }
    }
  }
  // Keine existierende Farbe in dieser Groesse? (sollte nicht vorkommen) -> abbrechen.
  if (!target) return;

  var targetColor = target.getAttribute('data-swatch-color');
  if (!targetColor) return;

  // Sprung ausfuehren -- mit Rekursionsschutz-Flag waehrend der Aktion.
  scope._mameidoAutoJumping = true;
  try {
    var nativeTarget = mameidoFindNativeColorInput(scope, targetColor);
    if (nativeTarget) {
      mameidoTriggerNativeColor(nativeTarget);
      mameidoMarkSelectedSwatch(root, targetColor);
    }
  } finally {
    // Flag erst nach der Event-Loop loesen: variant:change wird via setTimeout(...,0)
    // verarbeitet, daher den Schutz bis nach diesem Tick halten.
    setTimeout(function () { scope._mameidoAutoJumping = false; }, 0);
  }
}

/* Schritt 5a: Wendet das Slider-Sichtbarkeits-Limit FILTERBEWUSST an.
   - Nicht-existente Farben (data-mameido-avail="nonexistent") sind via CSS bereits
     ausgeblendet und zaehlen NICHT fuer das Limit.
   - Von den existierenden Farben (instock + soldout) zeigt der Slider nur die ersten
     <limit>; der Rest bekommt --hidden. "Alle anzeigen" erscheint nur, wenn es unter
     den EXISTIERENDEN noch versteckte gibt.
   - Sortier-Reihenfolge bleibt unveraendert (mameidoSortSwatches lief beim Init); wir
     lesen die Kacheln in aktueller DOM-Reihenfolge, das ist die sortierte Reihenfolge.
   - Im aufgeklappten Raster-Modus (data-swatch-expanded="true") wird NICHT limitiert
     (alle existierenden bleiben sichtbar) -- nur der Slider-Modus limitiert. */
function mameidoApplyVisibility(root) {
  if (!root) return;
  var grid = root.querySelector('[data-swatch-grid]');
  if (!grid) return;

  var limit = parseInt(root.getAttribute('data-visible-limit'), 10);
  if (isNaN(limit) || limit < 1) limit = 10;

  var expanded = root.getAttribute('data-swatch-expanded') === 'true';
  var showall = grid.querySelector('[data-swatch-showall]');

  // Nur die EXISTIERENDEN Kacheln (nicht "nonexistent") in DOM-Reihenfolge.
  var allSwatches = Array.prototype.slice.call(grid.querySelectorAll('.mameido-swatch'));
  var existing = allSwatches.filter(function (btn) {
    return btn.getAttribute('data-mameido-avail') !== 'nonexistent';
  });

  var hiddenCount = 0;
  existing.forEach(function (btn, i) {
    if (expanded) {
      // Raster-Modus: alle existierenden zeigen.
      btn.classList.remove('mameido-swatch--hidden');
    } else if (i < limit) {
      btn.classList.remove('mameido-swatch--hidden');
    } else {
      btn.classList.add('mameido-swatch--hidden');
      hiddenCount++;
    }
  });

  // "Alle anzeigen" nur im Slider-Modus + nur wenn es versteckte EXISTIERENDE gibt.
  if (showall) {
    if (!expanded && hiddenCount > 0) {
      showall.hidden = false;
    } else {
      showall.hidden = true;
    }
  }
}

// Hilfszustand: Ist eine Farbe in IRGENDEINER Groesse lieferbar / existent?
function mameidoStateAnySize(map, colorSlug) {
  var existsSoldout = false;
  for (var i = 0; i < map.length; i++) {
    if (map[i][0] === colorSlug) {
      if (map[i][2]) return 'instock';
      existsSoldout = true;
    }
  }
  return existsSoldout ? 'soldout' : 'nonexistent';
}

// Hilfszustand: Ist eine Groesse in IRGENDEINER Farbe lieferbar / existent?
function mameidoStateAnyColor(map, size) {
  var existsSoldout = false;
  for (var i = 0; i < map.length; i++) {
    if (map[i][1] === size) {
      if (map[i][2]) return 'instock';
      existsSoldout = true;
    }
  }
  return existsSoldout ? 'soldout' : 'nonexistent';
}

// Wendet die Markierung auf alle Swatch-Instanzen an.
// Theme-Editor: Wird ein Abschnitt neu geladen (Block hinzufügen, Einstellung ändern), ersetzt Shopify sein HTML.
// Dann Swatch-Block und Verfügbarkeit (damit auch die Benachrichtigen-Zeile bei ausverkaufter Variante) neu aufsetzen.
// Der Event kommt nur im Editor, auf der Shop-Seite läuft nichts davon.
document.addEventListener('shopify:section:load', function () {
  try {
    document.querySelectorAll('variant-swatches.mameido-swatches').forEach(function (root) {
      if (!root.getAttribute('data-swatch-ready')) mameidoInitSwatchInstance(root);
    });
    mameidoInitSwatchInteractions();
  } catch (e) {}
  setTimeout(mameidoApplyAvailabilityAll, 50);
  setTimeout(mameidoApplyAvailabilityAll, 400);
});

function mameidoApplyAvailabilityAll() {
  document.querySelectorAll('variant-swatches.mameido-swatches').forEach(function (root) {
    mameidoApplyAvailability(root);
  });
}

// Auf Variantenwechsel hoeren -> Markierung neu berechnen (beide Richtungen).
// Eigener Listener, additiv zu den bestehenden variant:change-Hooks.
document.addEventListener('variant:change', function () {
  // Kleiner Aufschub: erst nachdem die bestehenden Hooks (Markierung der aktiven
  // Swatch via mameidoMarkSelectedSwatch) gelaufen sind, lesen wir den Zustand.
  setTimeout(mameidoApplyAvailabilityAll, 0);
});
